<template>
  <div>
    <input
        ref=fileInput
        class="input-button"
        type="file"
        :id="uuid"
        @change="saveImage"
        :accept="accept"
    />
    <label :for="uuid">
      <!-- <v-img v-if="url != null" :src="url"></v-img> -->
    </label>
    <div @click="onclick()" class="clickable">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileInputButton",
  data() {
    return {
      url: "",
      file: null,
      fileName: null
    };
  },
  created: function() {
    this.file = this.value;
    // if (this.existedImageUrl) {
    //   this.image.url = this.existedImageUrl;
    // }
  },
  props: {
      accept: String,
    uuid: String,
    existedImageUrl: String,
    value: Object
  },
  methods: {
    onclick: function() {
      //   console.log("onclick");
      const input = document.getElementById(this.uuid);
      if (input) {
        input.click();
      }
    },
    saveImage(event) {
      let fileName = null;
      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      } else {
        fileName = event.target.value.split("\\").pop();
      }
      this.fileName = fileName;
      const file = event.target.files[0];

      const isMatchType = true;
      // file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      //   if (!isMatchType) {
      //     this.$message.error("album.msg.img_format");
      //   } else if (!isLt2M) {
      //     this.$message.error("album.msg.img_size");
      //   } else {
      //       }
      this.url = URL.createObjectURL(file);

      this.file = file;
      this.$emit("input", file);

      this.$emit("fileUpdated", file);

    this.$refs.fileInput.value = null;
      //   this.$refs.cover.clearFiles();
    }
  }
};
</script>

<style scoped>
.input-button {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.input-button:hover + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.album-input {
  cursor: pointer;
  background-color: #f9fafc;
  border-width: 1px;
  border-color: #e3e3e3;
  border-style: dashed;

  /* padding-top:  */
  height: 226px;
  width: 226px;
  display: flex;
  align-items: center;
}
.album-input-text {
  text-align: center;
  width: 100%;
}

.clickable {
    cursor: pointer;
}
</style>
